import '@babel/polyfill';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import 'leaflet/dist/leaflet.css';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/firebase/';
import panZoom from 'vue-panzoom';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(panZoom);

Vue.config.productionTip = false;

const app = new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app');

if (window.Cypress) {
    window.app = app;
}
